import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Zoom } from "react-reveal";
import { useQuery } from "react-query";
import HeaderInner from "../../Components/HeaderInner";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { useBusinessNameContext } from "../../context/BusinessName";
import { getCarCompaniesAPI } from "../../API/CarsAPI";
import { isClosedNow } from "../../utils/availability";
import ClosableCard from "../../new-components/closed-badge/ClosableCard";

function CarRentalCompanies() {
  const { businessName } = useBusinessNameContext();

  const location = useLocation();
  const navigate = useNavigate();

  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];

  const lang = sessionStorage.getItem("lang");

  const { data, isLoading, error } = useQuery(
    ["car-rental-companies", room_uuid, lang],
    () =>
      getCarCompaniesAPI({
        room_uuid,
        lang,
      })
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  if (error) {
    if (error?.response?.status === 404) {
      navigate(`/not-found`);
      return null;
    }

    return <div>Error fetching data</div>;
  }

  const responseData = data?.data?.data;

  if (!isLoading && data?.data?.status === false) {
    navigate(`/${room_uuid}/qr-scan`);
    return null;
  }

  const companies = responseData?.companies || [];
  const headerTitle =
    responseData?.center_header || responseData?.title || "Car Rental";

  if (!isLoading && companies.length === 1 && !isClosedNow(companies[0])) {
    navigate(`/${room_uuid}/car_rental/company/${companies[0].uuid}/cars`, {
      replace: true,
    });
    return null;
  }

  return (
    <>
      <HeaderInner headerName={headerTitle} />

      <main className="home-main bg-white pt-3">
        <div>
          {isLoading ? (
            <CustomBusinessServiceLoader
              businessName={businessName}
              loader={"carRental"}
            />
          ) : companies.length > 0 ? (
            companies.map((company) => {
              const companyImage =
                company?.logo ||
                company?.attachments?.find((item) => item?.type === "car_image")
                  ?.path ||
                company?.attachments?.[0]?.path ||
                "";

              return (
                <div id={company.name} key={company.uuid}>
                  <Zoom>
                    <ClosableCard
                      closed={isClosedNow(company)}
                      className="con-img-container v3"
                      onClick={() =>
                        navigate(
                          `/${room_uuid}/car_rental/company/${company.uuid}/cars`
                        )
                      }
                    >
                      <div className="con-img">
                        {companyImage && <img src={companyImage} alt="" />}
                        <p></p>
                      </div>
                    </ClosableCard>

                    <div className="con-text-container">
                      <p>{company.name}</p>
                      <hr className="mb-0 dark" />
                    </div>
                  </Zoom>
                </div>
              );
            })
          ) : null}
        </div>
      </main>
    </>
  );
}

export default CarRentalCompanies;
